
  // import { mapState } from 'vuex'
  import notifications from '~/mixins/pages/mission-control/notifications'
  export default {
    name: 'Theme3MobileNotification',
    mixins: [notifications],
    data() {
      return {
        displayNotification: false
      }
    },
    methods: {
      onClickHandler(item) {
        this.displayNotification = false
        this.onClickNotificationHandler(item)
      },
      onClickHandlerMessage() {
        this.displayNotification = false
        this.onClickHandlerRedirect()
      }
    }
  }
